import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";

export const selectDealerPricingRequest = (
  quoteId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: { pricingRequestId: string }): Promise<boolean> => {
      return fetchWithAuth<boolean>("selectDealerPricingRequest", quoteId, {
        requestOptions: {
          method: "post",
          body: JSON.stringify({
            pricingRequestId: payload.pricingRequestId,
          }),
        },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () =>
      defaultOnMutateSettled([["quoteDealerPricingRequests", quoteId]]),
  });
};
